class MainSearch extends SearchForm {
    constructor() {
        super();

        this.allSearchInputs = document.querySelectorAll(
            'input[type="search"]'
        );

        this.searchForms = [];

        this.allSearchInputs.forEach((input) => {
            if (input.form && !this.searchForms.includes(input.form)) {
                this.searchForms.push(input.form);
            }
        });

        this.setupEventListeners();
    }

    setupEventListeners() {
        if (!this.input) return;

        this.input.addEventListener(
            'focus',
            this.onInputFocus.bind(this)
        );

        /*
         * If there is only one search form, there is nothing
         * to synchronize.
         */
        if (this.allSearchInputs.length < 2) return;

        this.searchForms.forEach((form) => {
            form.addEventListener(
                'reset',
                this.onFormReset.bind(this)
            );
        });

        this.allSearchInputs.forEach((input) => {
            input.addEventListener(
                'input',
                this.onInput.bind(this)
            );
        });
    }

    onFormReset(event) {
        super.onFormReset(event);

        if (super.shouldResetForm()) {
            this.keepInSync('', event.target.querySelector('input[type="search"]'));
        }
    }

    onInput(event) {
        const target = event.target;

        this.keepInSync(target.value, target);
    }

    onInputFocus() {
        if (window.innerWidth >= 750) return;

        window.requestAnimationFrame(() => {
            this.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            });
        });
    }

    keepInSync(value, target) {
        this.allSearchInputs.forEach((input) => {
            if (input !== target) {
                input.value = value;
            }
        });
    }
}

if (!customElements.get('main-search')) {
    customElements.define('main-search', MainSearch);
}